


















import { Swipe, SwipeItem } from "vant";
import { Component, Vue, Provide, Prop, Emit } from "vue-property-decorator";
import Native from "../common/Native";
import { INewsItem } from "@/api/types.d.ts";
@Component({
  components: {
    Swipe,
    SwipeItem
  }
})
export default class Swiper extends Vue {
  /** 轮播图数据 */
  @Prop()
  private list!: Array<object>;
  @Prop()
  private itemClick?: Function;
  click(item: INewsItem) {
    if (this.itemClick) {
      this.itemClick(item);
    } else {
      this.$emit("itemClick", item);
    }
  }
}
